import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { CTASection } from "@/components/CTASection";
import { usePageMeta } from "@/hooks/usePageMeta";
import { POSTS } from "@/data/posts";

export default function InsightsPage() {
  usePageMeta({
    title: "Insights | BrandZenith",
    description:
      "Thinking from BrandZenith on AI, branding, attention and growth — for brands built for what's next.",
    path: "/insights",
  });

  return (
    <>
      <Navbar />
      <main>
        <PageHeader
          overline="Insights"
          title="Thinking that"
          accent="moves brands."
          copy="On AI, branding, attention and growth — from the studio floor."
        />
        <section className="relative pb-28 lg:pb-36">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {POSTS.map((p, i) => (
              <Reveal key={p.slug} delay={i * 0.1} className="h-full">
                <Link
                  to={`/insights/${p.slug}`}
                  data-testid={`insight-card-${i}`}
                  className="group flex flex-col h-full glass-card rounded-lg overflow-hidden transition-[border-color,box-shadow,transform] duration-500 hover:-translate-y-1.5 hover:border-[#6D00FF]/40 hover:shadow-[0_0_44px_-12px_rgba(109,0,255,0.5)]"
                >
                  <div className="relative aspect-[16/10] overflow-hidden">
                    <img
                      src={p.img}
                      alt={`${p.title} — BrandZenith insights`}
                      loading="lazy"
                      className="w-full h-full object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-105"
                    />
                    <div
                      aria-hidden="true"
                      className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"
                    />
                  </div>
                  <div className="p-7 flex flex-col flex-1">
                    <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-[#C43CFF] mb-3">
                      {p.category} · {p.readTime}
                    </p>
                    <h2 className="font-display text-lg sm:text-xl font-bold tracking-tight leading-snug mb-3 group-hover:text-white transition-colors duration-300">
                      {p.title}
                    </h2>
                    <p className="text-sm text-[#A6A6B0] leading-relaxed flex-1">{p.excerpt}</p>
                    <span className="mt-6 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-[#8B2CFF] group-hover:text-[#C43CFF] transition-colors duration-300">
                      Read Insight
                      <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </section>
        <CTASection />
      </main>
      <Footer />
    </>
  );
}
